import request from "./request";

// https://devapi.primestreet.io/lenders-api/swagger-ui/#/
const lender = {
  service() {
    return {
      listLoanOffices(params) {
        params.pageIndex = params.pageIndex ? params.pageIndex : 0;
        params.pageSize = params.pageSize ? params.pageSize : 10;
        params.sort = params.sort ? params.sort : "name,ASC";
        return request
          .get("/lenders-api/loan-offices", params)
          .then((resp) => {
            return {
              resp: resp,
              filter: params.name ? params.name : "",
            };
          })
          .catch((e) => {
            throw e;
          });
      },
      getLoanOffice(id) {
        return request.get(`/lenders-api/loan-offices/${id}`, null);
      },

      // Loan Officers endpoints below
      listLoanOfficers(params) {
        params.pageIndex = params.pageIndex ? params.pageIndex : 0;
        params.pageSize = params.pageSize ? params.pageSize : 10;
        params.sort = params.sort ? params.sort : "lastName,ASC";
        return request.get("/lenders-api/loan-officers", params);

        // params.sort = params.sort ? params.sort : "name,ASC";
        // return request
        //   .get("/lenders-api/loan-officers", params)
        //   .then((resp) => {
        //     return {
        //       resp: resp,
        //       filter: params.name ? params.name : "",
        //     };
        //   })
        //   .catch((e) => {
        //     throw e;
        //   });
      },
      getLoanOfficer(id) {
        return request.get(`/lenders-api/loan-officers/${id}`, null);
      },
      // Load Office Referrals
      getLoanOfficeReferrals(params) {
        params.pageIndex = params.pageIndex ? params.pageIndex : 0;
        params.pageSize = params.pageSize ? params.pageSize : 10;
        // params.sort = params.sort ? params.sort : "lastName,ASC";
        return request.get("/lenders-match-api/lender-assignments", params);
      },
      postLoanOfficer(data) {
        return request.post("/lenders-api/loan-officers", data, null);
      },
    };
  },
};
export default lender;
